import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router/index'
import store from './store'
import ElementPlus from 'element-plus' // 引入element-ui doc:https://element-plus.gitee.io/
import locale from 'element-plus/lib/locale/lang/zh-cn'
import './styles/element-variables.scss' // 引入element样式
import './styles/common.scss'
import SvgIcon from './components/SvgIcon'// svg
import '@/icons' // icon
import { loadStyle } from './util/util'
import './permission'

// 加载阿里 icon 图标
loadStyle('//at.alicdn.com/t/font_2494106_akkfakrb9ui.css')

// 作为 vue3 的启动函数，返回一个应用实例
const app = createApp(App)
// 禁止控制台输出警告日志
app.config.warnHandler = () => null
app.config.globalProperties.$baseURL = process.env.VUE_APP_BASE_API + '/'
app.config.globalProperties.$imgURL = process.env.VUE_APP_IMG_URL + '/'
app.component('svg-icon', SvgIcon)
  .use(ElementPlus, { locale })
  .use(store)
  .use(router)
  .mount('#app')
